export default __webpack_public_path__ + "65feede031e8cef6f0338a768cce7bb1.jpg";